// extracted by css-extract-rspack-plugin
export default {"Divider":"ziDNq","MainFormContainer":"zmPCp","SelectButton":"LExoa"};